/**
 * PtyAdapter stub. Both shells start from this; Desktop will replace it
 * with an IPC-to-node-pty-daemon implementation and Web will eventually
 * talk to WorkspaceRelay (`terminal:*`, KTK-125) over WSS. The MVP slice
 * (sign-in + channels + chat + scout viewer) doesn't attach any PTYs, so
 * a throw-on-attach stub keeps the adapter shape without forcing a real
 * client before either shell needs one.
 */
export const browserPtyAdapterStub = {
    async listHosts() {
        return [];
    },
    async listSessions(_hostId) {
        return [];
    },
    async attach(_sessionId, _options) {
        throw new Error("PTY attach is not implemented on this shell yet.");
    },
    onHostsChanged(_listener) {
        return () => undefined;
    },
};
//# sourceMappingURL=pty.js.map